<template >
    <span class="text-medium created-at">
        <mdicon class="x-small-icon mr-1" name="calendar"></mdicon>
        {{ date }}
    </span>
</template>
<script>
// screen width
import { VueScreenSizeMixin } from 'vue-screen-size';

export default {
    props: ['created_at', 'fuzzy'],
    mixins: [VueScreenSizeMixin],
    computed: {
        date() {
            return this.$fuzzyDate(this.created_at, this.fuzzy)
        },
    },
}
</script>
<style lang="scss">

.created-at {
    display: flex;
    align-items: center;
    padding-top: 2px;
    font-size: 12px
}
</style>
